module.exports = __webpack_public_path__ + "static/media/O5e8asH2JpQ.9d13acb0.jpg";